import React, { useEffect, useState } from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import { Box, Container } from "@mui/material";
import Footer from "../../component/users/Footer";
import NotificationComponent from "../../component/users/notifications/NotificationComponent";

const Notification = () => {
  const notifications = useSelector((state) => state.notifications.data);
  const user = useSelector((state) => state.user.loading);
  const [notificationState, setNotificationState] = useState([]);
  // "";

  useEffect(() => {
    setNotificationState(notifications);
  }, [notifications]);

  //   return notifications.map((data) => <div>{data.message_text}</div>);
  return (
    <>
      <Header />
      {user ? (
        "loading..."
      ) : (
        <Box className="userLayout">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743", paddingBottom: "0px" }}
          >
            <NotificationComponent data={notificationState} />
          </Container>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default Notification;
